import apps from './routes/apps';
import dashboard from './routes/dashboard';
import uiElements from './routes/ui-elements/index';
import pages from './routes/pages';
import chartsMaps from './routes/charts-maps';
import formsTable from './routes/forms-tables';
import others from './routes/others';
import siteManagement from './routes/site-management';
import userManagement from './routes/user-management';
import serialManagement from './routes/serial-management';
import searchInvoiceManagement from './routes/search-invoice-management';
import eInvoice from './routes/e-invoice';
import eInvoiceConfiguration from './routes/e-invoice-configuration';
import actionLog from './routes/action-log';
import transferHistory from './routes/transfer-history';
export default [
  { path: '/', redirect: { name: 'home' } },
  ...apps,
  ...dashboard,
  ...pages,
  ...chartsMaps,
  ...formsTable,
  ...uiElements,
  ...others,
  ...siteManagement,
  ...userManagement,
  ...serialManagement,
  ...searchInvoiceManagement,
  ...eInvoice,
  ...eInvoiceConfiguration,
  ...actionLog,
  ...transferHistory,
  {
    path: '*',
    redirect: 'error-404',
  },
];
